module.exports = __webpack_public_path__ + "img/equip.3db83892.svg";